import tools from './tools';

const user = () => import('./user');
const userList = () => import('./userList');
const message = () => import('./message');
const plantask = () => import('./plantask');
const editUser = () => import('./editUser');
const pdfView = () => import('./pdfview');
const h5Channel = () => import('./bi/channel');
const h5Visit = () => import('./bi/visit');
const h5Sayer = () => import('./bi/sayer');
const h5TraningVisit = () => import('./trainingVister');

const h5Router = [
  {
    path: '/h5/tools',
    name: 'h5Tools',
    component: tools,
    meta: {
      c: 'h5', a: 'tools', noLayout: true, noAuth: true
    }
  },
  {
    path: '/h5/user/:crmid',
    name: 'h5User',
    component: user,
    meta: {
      c: 'h5', a: 'user', noLayout: true
    }
  },
  {
    path: '/h5/editUser/:crmid',
    name: 'h5EditUser',
    component: editUser,
    meta: {
      c: 'h5', a: 'editUser', noLayout: true, noAuth: false
    }
  },
  {
    path: '/h5/userList',
    name: 'h5UserList',
    component: userList,
    meta: {
      c: 'h5', a: 'userList', noLayout: true
    }
  },
  {
    path: '/h5/message',
    name: 'h5Message',
    component: message,
    meta: {
      c: 'h5', a: 'message', noLayout: true
    }
  },
  {
    path: '/h5/plantask',
    name: 'h5Plantask',
    component: plantask,
    meta: {
      c: 'h5', a: 'plantask', noLayout: true
    }
  },
  {
    path: '/h5/pdfview',
    name: 'h5PdfView',
    component: pdfView,
    meta: {
      c: 'h5', a: 'pdfView', noLayout: true, noAuth: true
    }
  },
  {
    path: '/h5/bi/channel',
    name: 'h5Channel',
    component: h5Channel,
    meta: {
      c: 'h5', a: 'channel', noLayout: true
    }
  },
  {
    path: '/h5/bi/visit',
    name: 'h5Visit',
    component: h5Visit,
    meta: {
      c: 'h5', a: 'visit', noLayout: true
    }
  },
  {
    path: '/h5/bi/sayer',
    name: 'h5Sayer',
    component: h5Sayer,
    meta: {
      c: 'h5', a: 'sayer', noLayout: true
    }
  },
  {
    path: '/h5/trainingVister',
    name: 'h5TraningVisit',
    component: h5TraningVisit,
    meta: {
      c: 'h5', a: 'TraningVisit', noLayout: true, noAuth: true
    }
  }
];

export default h5Router;
